var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "project-edit-modal",
        pivotY: 0.2,
        width: "590",
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-img-container" }, [
        _c("img", {
          staticClass: "modal-img",
          attrs: { src: _vm.urlForStatic(_vm.titleImage) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("project-edit-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title" }, [
        _vm._v("\n        Редактировать название проекта\n    ")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.nameActiveProject,
            expression: "nameActiveProject"
          }
        ],
        staticClass: "modal-text-input",
        attrs: { type: "text" },
        domProps: { value: _vm.nameActiveProject },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.nameActiveProject = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-button", on: { click: _vm.writeName } }, [
        _vm._v("\n        Сохранить изменения\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }